/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_LoginInputs */



/**
* | output |
* | --- |
* | "Login failed." |
*
* @param {Auth_Error_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_login = /** @type {((inputs?: Auth_Error_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion échouée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio de sesión fallido.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Login falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accesso fallito.")
	return /** @type {LocalizedString} */ ("Login failed.")
});